import {
  ref,
  toRef,
} from "vue";

import PuxTablePlugin from "../plugin/PuxTablePlugin";

import {
  cloneDeep,
  isArray,
} from "lodash-es";

export default function ModelsAPI(props) {
  const limitStart = toRef(props, "limitStart");
  const offsetStart = toRef(props, "offsetStart");
  const sortingStart = toRef(props, "sortingStart");
  const modelFiltersStart = toRef(props, "modelFiltersStart");
  const modelIsTableWithoutScrollStart = toRef(props, "modelIsTableWithoutScrollStart");

  const appliedModelFilters = ref(cloneDeep(modelFiltersStart.value));
  const filterPrioritization = ref(undefined); // 1) Url 2) Session 3) Default
  const limitLocal = ref(undefined);
  const mainModelFilters = ref({});
  const modelColumnsOrderingLocal = ref([]);
  const modelColumnsVisible = ref({});
  const modelIsTableWithoutScrollStartLocal = ref(modelIsTableWithoutScrollStart.value);
  const modelSortLocal = ref([]);
  const modelView = ref(undefined);
  const offsetLocal = ref(offsetStart.value);
  const puxTableRef = ref(undefined);
  const unappliedModelFilters = ref(cloneDeep(modelFiltersStart.value));
  const viewCurrent = ref(undefined);

  const {
    getSyConfigsValue,
  } = PuxTablePlugin.SyConfigAPI();

  const initLimit = () => {
    if (limitStart.value) {
      limitLocal.value = limitStart.value;
    } else {
      limitLocal.value = +getSyConfigsValue("default_ntc_anzahl", 10);
    }
  };

  const initModelSortLocal = () => {
    if (isArray(sortingStart.value)) {
      modelSortLocal.value = cloneDeep(sortingStart.value);
    } else if (sortingStart.value) {
      modelSortLocal.value = [sortingStart.value];
    }
  };

  return {
    appliedModelFilters,
    filterPrioritization,
    initLimit,
    initModelSortLocal,
    limitLocal,
    mainModelFilters,
    modelColumnsOrderingLocal,
    modelColumnsVisible,
    modelIsTableWithoutScrollStartLocal,
    modelSortLocal,
    modelView,
    offsetLocal,
    puxTableRef,
    unappliedModelFilters,
    viewCurrent,
  };
}
